export default __webpack_public_path__ + "static/media/2080.92131bb3.png";